import { Component } from '@angular/core';

import { UserTypeState } from '../user-type.state';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss'],
})
export class OrganizationComponent extends UserTypeState {}
